<template>
    <div>
        <form @submit.prevent="submit" autocomplete="off">
            <div class="row">
                <div class="col-12 col-xl-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-label-group">
                                        <input class="form-control" id="name" name="name"
                                               placeholder="Enter name"
                                               type="text"
                                               v-bind:class="[this.name.validated ? this.name.valid ? 'is-valid' : 'is-invalid' : '']"
                                               v-model="form.name"
                                               v-validate="'required'">
                                        <label for="name">{{ $t("brand.Name") }}*</label>
                                        <div class="invalid-feedback">{{ errors.first('name') }}</div>
                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-primary" type="submit">{{$t('global.Submit')}}</button>
                            <button @click="deleteBrand()" class="btn btn-neutral red ml-2" type="button"
                                    v-if="!isNew">
                                {{$t('global.Delete')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'

    export default {
        name: 'appCreate',
        data() {
            return {
                isNew: true,
                dispatchLink: 'SAVE_BRAND',
                error: '',
                checkbox: true,
                form: {
                    name: ''
                }
            }
        },
        computed: {
            ...mapFields(['name'])
        },
        async mounted() {
            //Check create or update
            this.isNew = true;
            this.dispatchLink = 'SAVE_BRAND';
            if(this.$route.params.id){
                this.isNew = false;
                this.dispatchLink = 'UPDATE_BRAND';

                let customer = await this.$store.dispatch('GET_BRAND', this.$route.params.id)
                this.form = customer
            }
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$store.dispatch(this.dispatchLink, this.form)
                            .then(() => {
                                this.$swal({
                                    title: this.$t('swal.logout.SuccessTitle'),
                                    text: this.$t('swal.logout.SuccessMsg'),
                                    type: "success",
                                    toast: true,
                                    showConfirmButton: false,
                                    position: 'top-end',
                                    timer: 1200
                                });

                                if(this.isNew){
                                    //Form leegmaken
                                    this.form = {}
                                    this.$validator.reset()
                                }
                            })
                            .catch((error) => {
                                if (error.errors.name) {
                                    this.$validator.errors.add({
                                        field: 'name',
                                        msg: error.errors.name[0]
                                    })
                                    this.fieldsVee.name.valid = false
                                }
                            })
                    }
                })
            },
            deleteBrand() {
                //Confirmation dialog, are you sure?
                this.$swal({
                    title: this.$t('swal.general.Title'),
                    text: this.$t('swal.delete.Text'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: this.$t('swal.general.CancelButtonText'),
                    confirmButtonText: this.$t('swal.delete.ConfirmButtonText')
                }).then(async (result) => {
                        //Sure? -> Delete
                        if (result.value) {

                            let resp = await this.$store.dispatch('DELETE_BRAND', this.$route.params.id)

                            //Success message
                            this.$swal({
                                title: this.$t('swal.delete.SuccessTitle'),
                                text: resp.message,
                                type: "success",
                                toast: true,
                                showConfirmButton: false,
                                position: 'top-end',
                                timer: 1200
                            });

                            //Terugsturen naar index
                            this.$router.push({name: 'measurementIndex'})
                        }
                    }
                )
            },
        }
    }
</script>
<style>
    .custom-range {
        width: 100%;
        height: 1.4rem;
        padding: 0;
        background-color: transparent;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
</style>
